import { render } from "./DashboardManager.vue?vue&type=template&id=c250aa8e"
import script from "./DashboardManager.vue?vue&type=script&lang=js"
export * from "./DashboardManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__